module.exports = __webpack_public_path__ + "img/face-grin-squint.14564398.svg";